import cimg1 from '../images/case/img-1.jpg'
import cimg2 from '../images/case/img-2.jpg'
import cimg3 from '../images/case/img-3.jpg'
import cimg4 from '../images/case/img-4.jpg'
import cimg5 from '../images/case/img-5.jpg'
import cimg6 from '../images/case/img-6.jpg'

import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'


const Cases = [
    {
        Id: '1',
        cTitle: 'Law of Contracts', 
        cImg:cimg1,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '2',
        cTitle: 'Employment, Labour, Pension & Retirement Benefits Scheme', 
        cImg:cimg2,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '3',
        cTitle: 'Corporate & Commercial Laws', 
        cImg:cimg3,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '4',
        cTitle: 'Conveyancing & Real Estate Law', 
        cImg:cimg4,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '5',
        cTitle: 'Litigation & Dispute Resolution', 
        cImg:cimg5,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '6',
        cTitle: 'Family & Matrimonial Laws', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '7',
        cTitle: 'Probate, Succession & Trust Laws', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '8',
        cTitle: 'Intellectual Property Rights', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '9',
        cTitle: 'Banking, Liquidation & Restructuring', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '10',
        cTitle: 'Project Finance & Insurance Laws', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '11',
        cTitle: 'Infrastructure, Construction & Energy Projects', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '12',
        cTitle: 'Tax Laws', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '13',
        cTitle: 'Alternative Dispute Resolution', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '14',
        cTitle: 'Consultancy, Research & Development', 
        cImg:cimg6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    }
]

export default Cases;